export const CostIconSvg = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
    <path d="M12 6v2m0 8v2" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M9 10a3 3 0 1 1 6 0c0 2-3 3-3 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="17" r="0.5" fill={color} stroke={color} strokeWidth="1"/>
  </svg>
);
